import App from './App.svelte';

const app = new App({
    // target: document.body
    target: document.getElementById('quiz-goes-here'),
    props: {
        allQuizData: jsonQuizData,
    },
});

export default app;
